// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"159":"03148c19be551e50","266":"9529152cd8d94929"}[chunkId] + ".js";
};